"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FoodType;
(function (FoodType) {
    FoodType["coffee"] = "coffee";
    FoodType["chocolate"] = "chocolate";
    FoodType["redMeat"] = "redMeat";
    FoodType["whiteMeat"] = "whiteMeat";
    FoodType["fish"] = "fish";
    FoodType["lamb"] = "lamb";
    FoodType["beef"] = "beef";
    FoodType["cheese"] = "cheese";
    FoodType["pork"] = "pork";
    FoodType["turkey"] = "turkey";
    FoodType["chicken"] = "chicken";
    FoodType["tuna"] = "tuna";
    FoodType["eggs"] = "eggs";
    FoodType["potatoes"] = "potatoes";
    FoodType["rice"] = "rice";
    FoodType["nuts"] = "nuts";
    FoodType["beans"] = "beans";
    FoodType["tofu"] = "tofu";
    FoodType["vegetables"] = "vegetables";
    FoodType["milk"] = "milk";
    FoodType["fruit"] = "fruit";
    FoodType["lentils"] = "lentils";
})(FoodType = exports.FoodType || (exports.FoodType = {}));
